// i18n ignore
import { omit } from 'lodash';
/**
 * 语言常量配置
  * 包含语言代码到中文名称和原生名称的映射
*/
/** 语言代码到中文名称的映射 */
import i18nLangMap from '../../modules/i18n.json';
export const LANG_LABELS = i18nLangMap;
/** 语言代码到原生语言名称的映射（用于语言选择器显示） */
export const LANG_NATIVE_LABELS = {
    'en-US': 'English',
    'ja-JP': '日本語',
    'zh-CN': '简体中文',
    'zh-TW': '繁體中文',
    'ko-KR': '한국어',
    'fr-FR': 'Français',
    'de-DE': 'Deutsch',
    'es-ES': 'Español',
    'pt-PT': 'Português',
    'pt-BR': 'Português (Brasil)',
    'th-TH': 'ไทย',
    'vi-VN': 'Tiếng Việt',
};
export const getAvailableLangs = () => omit(LANG_LABELS, ['en-US', 'zh-CN']);
/** 获取语言的中文名称 */
export const getLangLabel = (lang) => LANG_LABELS[lang] || lang.toUpperCase();
/** 获取语言的原生名称 */
export const getLangNativeLabel = (lang) => LANG_NATIVE_LABELS[lang] || lang.toUpperCase();
